// src/stores/permissionStore.js
import { create } from 'zustand';
import useAuthStore from './authStore';

/**
 * Permission store that wraps the auth store's permission functionality
 * This store provides access to permission-related functions
 */
const usePermissionStore = create((set, get) => ({
  // Check if user has a specific permission
  hasPermission: (resource, action) => {
    return useAuthStore.getState().hasPermission(resource, action);
  },
  
  // Check if user has admin access
  isAdmin: () => {
    const { user } = useAuthStore.getState();
    return user?.role === 'admin' || user?.role === 'superadmin';
  },
  
  // Check if user has super admin access
  isSuperAdmin: () => {
    const { user } = useAuthStore.getState();
    if (!user?.role) return false;
    
    // Normalize role to lowercase and check against possible formats
    const normalizedRole = user.role.toLowerCase();
    const superAdminRoles = ['superadmin', 'super-admin', 'super_admin'];
    return superAdminRoles.includes(normalizedRole);
  }
}));

export default usePermissionStore;